import React, { useState } from "react";
import { Col, Form, Row, Button, Table, InputGroup } from "react-bootstrap";
import { SContainer } from "../components/BasicComponents";
import AppNavbar from "../components/Navbars/AppNavbar";

const io = require("socket.io-client");

const tokens = [
  //teacher
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InRlYWNoZXJAZXZvbGl0ZXN0LnBvbGltaS5pdCIsImlhdCI6MTY1NDkwNTc5NX0.nWa8LoHd9yvZtPT1lWmUj6MMUmpaKswADKJ75pzPUtg",
  //students
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQwQGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.m9MBWt9Zs0hXEz5cKIwkJpMWLm4ehUmKvVBv7rSIe0s",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQxQGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.3BMeFW7NrOed0XCj1ThQECHXk8G9pTGuBC6-E_Op7y4",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQyQGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.gcODjW4HDU7ekHKri7C8oBUP6ppIpMHIdNM_KElnCUQ",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQzQGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.sYiAnV-svItAytDp_nKs1Aoj6SLwPhMv5hpy2cQd9Po",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQ0QGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.To-EYFl6_coOECUCkUYNzKw6nmc7iFRpJZd_yXCG3Uo",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQ1QGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.0DvXqp7twknhRyDRV3HqcMkj91Er5md8wZ6qhZP_3OM",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQ2QGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.lG0hFKTKQt5QBslHLKYz9w5wKVmQvtQpGjIMEsDnLIY",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQ3QGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.-l461uHKFjrNslwK-sVyk6EJ4fys6hdC9RG0vI6Vo-E",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQ4QGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.G8Orj1yCl-q0AMDC9JE6_Y1QG0_VkbCIaesfJR4cmtc",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0dWRlbnQ5QGV2b2xpdGVzdC5wb2xpbWkuaXQiLCJpYXQiOjE2NTQ5MDU3OTV9.dB8d0KZuXKB9OvzGuHdkj4oyGqtJdyW4LOf6tw9e8uc",
];

//TODO: if needed for testing, custom values to events need to be implemented both in socket calls and UI

const SocketTestingPage = () => {
  const users = new Array(10).fill(0).map((_, i) => ({
    name: `Student ${i}`,
    surname: `Test ${i}`,
    email: `student${i}@evolitest.polimi.it`,
    token: tokens[i + 1],
  }));

  const teacher = {
    name: "Teacher",
    surname: "Test",
    email: "teacher@evolitest.polimi.it",
    token: tokens[0],
  };

  const [roomCode, setRoomCode] = useState("");

  return (
    <SContainer fluid fill="true">
      <Col>
        <AppNavbar />
      </Col>
      <SContainer>
        <Row>
          <h3 className="w-auto">Join Room</h3>
          <InputGroup className="w-25" value={roomCode} onChange={(e) => setRoomCode(e.target.value)}>
            <Form.Control placeholder="room code" aria-describedby="basic-addon1" />
            <Button
              onClick={() => {
                teacher.socket = io("ws://localhost:5000", { auth: { token: teacher.token } });
                teacher.socket.emit("connection/teacherJoin", { room: roomCode });
                users.forEach((u) => {
                  u.socket = io("ws://localhost:5000", { auth: { token: u.token } });
                  u.socket.emit("connection/studentJoin", { room: roomCode });
                });
              }}
            >
              Button
            </Button>
          </InputGroup>
        </Row>
        <Table>
          <thead>
            <tr>
              <th>teacher email</th>
              <th>understanding</th>
              <th>reactions</th>
              <th>interactions</th>
              <th>connection</th>
            </tr>
          </thead>
          <tbody>
            <UserRow user={teacher} index={-1} room={roomCode} isTeacher={true} />
          </tbody>
        </Table>
        <Table>
          <thead>
            <tr>
              <th>student email</th>
              <th>understanding</th>
              <th>reactions</th>
              <th>interactions</th>
              <th>connection</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, i) => (
              <UserRow user={user} index={i} room={roomCode} />
            ))}
          </tbody>
        </Table>
      </SContainer>
    </SContainer>
  );
};

const UserRow = ({ user, index, room, isTeacher = false }) => {
  const [sliderValue, setSliderValue] = useState(2);

  const [messageValue, setMessageValue] = useState("");
  const [noteValue, setNoteValue] = useState("");

  return (
    <tr className="p-2" key={index}>
      <td>{user.email}</td>
      <td>
        <Form.Range
          min={1}
          max={3}
          value={sliderValue}
          onChange={(e) => {
            setSliderValue(e.target.value);
            user.socket.emit("feedback/understanding", { value: e.target.value, videoTs: 0 });
          }}
        />
      </td>
      <td>
        <div className="d-flex flex-row">
          {new Array(3).fill(0).map((_, i) => (
            <Button
              onClick={() => {
                const reactionValue = i + 0;
                user.socket.emit("feedback/understanding", { value: reactionValue, videoTs: 0 });
              }}
            >
              {i}
            </Button>
          ))}
        </div>
      </td>
      <td>
        <div className="d-flex flex-column">
          <InputGroup className="my-1">
            <Form.Control
              placeholder="new message"
              aria-describedby="basic-addon1"
              onChange={(e) => setMessageValue(e.target.value)}
            />
            <Button
              id="button-addon1"
              onClick={() => {
                user.socket.emit("chat/message", { text: messageValue, videoTs: 0, slideNumber: 0 });
              }}
            >
              Send
            </Button>
          </InputGroup>
          <InputGroup className="my-1">
            <Form.Control
              placeholder="new note"
              aria-describedby="basic-addon2"
              onChange={(e) => setNoteValue(e.target.value)}
            />
            <Button
              id="button-addon2"
              onClick={() => {
                user.socket.emit("notes/note", { text: noteValue, videoTs: 0, slideNumber: 0, isPrivate: false });
              }}
            >
              Publish
            </Button>
          </InputGroup>
        </div>
      </td>
      <td>
        <div className="d-flex flex-row">
          <Button
            className="mx-1"
            onClick={() => {
              user.socket = io("ws://localhost:5000", { auth: { token: user.token } });
              console.log(room);
              user.socket.emit(isTeacher ? "connection/teacherJoin" : "connection/studentJoin", { room: room });
            }}
          >
            Join
          </Button>
          <Button
            className="mx-1"
            onClick={() => {
              user.socket.close();
            }}
          >
            Leave
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default SocketTestingPage;
